import { ThemeIcon, Tooltip } from "@mantine/core";
import {
  IconBrandAzure,
  IconFileCertificate,
  IconFileUpload,
  IconLanguage,
} from "@tabler/icons-react";
import { SOURCE_LABEL } from "./collectionMeta";

/** Small icon for a document's source (`blob` / `upload` / `veeva` / `derived`). */
export function SourceIcon({ kind }: { kind: string }) {
  const Icon =
    kind === "veeva"
      ? IconFileCertificate
      : kind === "blob"
        ? IconBrandAzure
        : kind === "derived"
          ? IconLanguage
          : IconFileUpload;
  const color =
    kind === "veeva" ? "teal" : kind === "blob" ? "blue" : kind === "derived" ? "grape" : "gray";
  const label = SOURCE_LABEL[kind] ?? kind;
  return (
    <Tooltip label={label}>
      <ThemeIcon variant="light" color={color} size={24} radius="sm" aria-label={label}>
        <Icon size={14} />
      </ThemeIcon>
    </Tooltip>
  );
}
